<button
        type="button"
        #trigger
        class="btn btn-link p-0 lh-1 text-decoration-none report-bug-trigger"
        [class.report-bug-trigger--attention]="highlighted()"
        [tooltip]="(highlighted() ? 'Found a problem? Report a bug' : 'Report a bug') | translate"
        placement="left"
        boundariesElement="viewport"
        containerClass="me-3"
        (click)="onBugClick()"
>
    <i class="fa-solid fa-bug"></i>
</button>

@defer (when popupRequested) {
    <app-report-bug-popup
            [origin]="trigger"
            [startRequestId]="reportStartRequestId"
    ></app-report-bug-popup>
}
